export const TABS = {
    MODULE: 'MODULE',
    CHANGABLE: 'CHANGABLE'
};
export const TABS_TEXTS = {
    [TABS.MODULE]: 'Модульные покрытия',
    [TABS.CHANGABLE]: 'Сервис сменных ковров'
};
